/**
 * Centralized exports for all constants
 */

// Export all constants
export * from './Colors';
export * from './Strings';
export * from './Styles';
export * from './Urls';
export * from './marketplace';
export * from './operations';

export const CHAT_CONSTANTS = {
  FONT_FAMILY: 'Roboto',
  FONT_SIZE: 14,
  LINE_HEIGHT: 20,
  CURRENT_USER_ID: 1,
  ROBOT_USER_ID: 2,
} as const;

// Marketplace moderation constants (from old app)
export const MARKETPLACE_KEYWORDS = [
  'sell', 'buy', 'sale', 'selling', 'buying', 'trade', 'trading',
  'swap', 'swapping', 'exchange', 'exchanging', 'offer', 'offering',
  'wanted', 'want', 'need', 'looking for', 'seeking', 'price',
  'cost', 'fee', 'payment', 'money', 'cash', 'free', 'giveaway',
  'donate', 'donation', 'marketplace', 'market', 'store', 'shop',
  'shopping', 'purchase', 'purchasing', 'acquire', 'acquiring'
];

// Content moderation status
export const CREATE_COMMENT_STATUS = {
  CREATED: 200,
  SHOW_MODERATION_ALERT: 202,
} as const;

// Comment image dimensions (matching legacy app)
export const COMMENT_IMAGE_CONSTANTS = {
  PARENT_COMMENT_IMAGE_HEIGHT: 120,
  CHILD_COMMENT_IMAGE_HEIGHT: 80,
  IMAGE_BORDER_RADIUS: 4,
  IMAGE_SEPARATOR_SIZE: 8,
} as const;

export const DESIGN_SYSTEM_CONSTANTS = {
  // ChatTooltip component
  CHAT_TOOLTIP: {
      ICON_SIZE: 10,
  },

  // Common UI values
  OPACITY: {
      DISABLED: 0.6,
      SEMI_TRANSPARENT: 0.8,
  },

  // Font weights (using string values for consistency)
  FONT_WEIGHTS: {
      LIGHT: '400',
      SEMIBOLD: '600',
      BOLD: '700',
  },
} as const;

// Report origins
export * from './user';

// DM Notification Type ID (from legacy app)
export const DM_NOTIFICATION_TYPE_ID = "658ce791-458c-4af0-995c-e5646249b440";

// Stream Chat Filter and Sort
export const STREAM_CHAT_SORT = { last_message_at: -1 };




